
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired76b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired76b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $bae440d65ca66e9c$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["l53ZJ","index.e648bba4.js","5Aif5","sprite.02b3eaa4.svg","f6LxU","library.d5f3b896.js","8pNXe","library.runtime.3a590514.js"]'));

parcelRequire("8BLYq");
parcelRequire("ghd3k");

var $asj7U = parcelRequire("asj7U");

var $g2HCo = parcelRequire("g2HCo");

var $jkGDt = parcelRequire("jkGDt");

var $cDe6Z = parcelRequire("cDe6Z");

var $aXXGU = parcelRequire("aXXGU");

var $1GAPJ = parcelRequire("1GAPJ");
const $b5daf3048a692912$export$5611ca9af52ffe5b = {
    width: "280px",
    position: "right-top",
    distance: "10px",
    timeout: 2000,
    backOverlay: false,
    showOnlyTheLastOne: true,
    clickToClose: true,
    fontFamily: "Quicksand",
    fontSize: "16px",
    cssAnimationDuration: 800,
    useIcon: false,
    useFontAwesome: true,
    fontAwesomeIconStyle: "basic",
    fontAwesomeIconSize: "15px",
    failure: {
        background: "rgb(255, 0, 27, 1)",
        textColor: "#fff"
    },
    warning: {
        background: "rgb(255, 0, 27, 1)",
        textColor: "#fff"
    }
};



var $26jpS = parcelRequire("26jpS");
(0, $asj7U.searchFormRef).addEventListener("submit", $b1a1b1a5164248f9$var$onSubmit);
async function $b1a1b1a5164248f9$var$onSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const searchValue = form.elements.searchMovies.value.trim();
    (0, $26jpS.createCurrentPageFromStorage)((0, $aXXGU.paginationSettings).startPage, "SEARCH_MOVIES", searchValue);
    if (searchValue === "") {
        (0, $1GAPJ.Notify).warning("Please enter the movie title!", (0, $b5daf3048a692912$export$5611ca9af52ffe5b));
        return;
    }
    const searchMovies = await (0, $jkGDt.getSearchMovies)(searchValue, (0, $aXXGU.paginationSettings).startPage);
    (0, $g2HCo.checkingForMoviesAndRender)((0, $asj7U.moviesListRefs).homeMoviesList, searchMovies, (0, $cDe6Z.movieListStubTitles).search);
    form.reset();
}


parcelRequire("jzMJC");
parcelRequire("dsYso");
parcelRequire("jkGDt");
parcelRequire("g5Oyh");

var $jkGDt = parcelRequire("jkGDt");

var $asj7U = parcelRequire("asj7U");

var $g2HCo = parcelRequire("g2HCo");

var $cDe6Z = parcelRequire("cDe6Z");

var $asj7U = parcelRequire("asj7U");

var $g2HCo = parcelRequire("g2HCo");

var $jkGDt = parcelRequire("jkGDt");

var $cDe6Z = parcelRequire("cDe6Z");

var $26jpS = parcelRequire("26jpS");
async function $d5e3b39806f92aa7$export$876405d8b5e4b416(renderPage) {
    (0, $26jpS.createCurrentPageFromStorage)(renderPage, "TRENDING_MOVIES", "");
    const trendingMovies = await (0, $jkGDt.getTrendingMovies)(renderPage);
    (0, $g2HCo.checkingForMoviesAndRender)((0, $asj7U.moviesListRefs).homeMoviesList, trendingMovies, (0, $cDe6Z.movieListStubTitles).common);
}



var $4S1lB = parcelRequire("4S1lB");

var $aXXGU = parcelRequire("aXXGU");
const $7fb3b4c0b1621dfa$var$currentPage = (0, $4S1lB.getDataFromSessionStorage)("currentSetPagination");
async function $7fb3b4c0b1621dfa$var$homeRender() {
    (0, $asj7U.headerLinkRefs).home.classList.add("header-link-active");
    if (!$7fb3b4c0b1621dfa$var$currentPage) return (0, $d5e3b39806f92aa7$export$876405d8b5e4b416)((0, $aXXGU.paginationSettings).startPage);
    if ($7fb3b4c0b1621dfa$var$currentPage.type === "SEARCH_MOVIES") {
        const searchMovies = await (0, $jkGDt.getSearchMovies)($7fb3b4c0b1621dfa$var$currentPage.query, $7fb3b4c0b1621dfa$var$currentPage.page);
        (0, $g2HCo.checkingForMoviesAndRender)((0, $asj7U.moviesListRefs).homeMoviesList, searchMovies, (0, $cDe6Z.movieListStubTitles).search);
    } else (0, $d5e3b39806f92aa7$export$876405d8b5e4b416)($7fb3b4c0b1621dfa$var$currentPage.page || (0, $aXXGU.paginationSettings).startPage);
}
$7fb3b4c0b1621dfa$var$homeRender();



var $asj7U = parcelRequire("asj7U");

var $gyx0h = parcelRequire("gyx0h");

var $7UV4g = parcelRequire("7UV4g");
var $c5146e64d7a7aab8$exports = {};
$c5146e64d7a7aab8$exports = new URL("sprite.02b3eaa4.svg", import.meta.url).toString();


const $cef524a0898173f1$export$42ca48a105b71d6e = ()=>{
    return `
  <strong class='auth-title'>Sign Up</strong>
    <form class="signUp-form">
    <div class='input-wrapper'>
    <label class='auth-label' for="Name">Name</label>
    <input class="auth-input" placeholder="Name" name="name" type="text" />
    </div>
    <div class='input-wrapper'>
    <label class='auth-label' for="Email">Email</label>
      <input class="auth-input" placeholder="Email" name="email" type="email" />
      </div>
      <div class='input-wrapper'>
      <label class='auth-label' for="Password">Password</label>
      <input class="auth-input" placeholder="Password" name="password" type="password" />
      </div>
       <div class='submit-wrapper'>
        <button type='submit' class="auth-submit-btn submit-signUp">Sign Up</button>
        <button type='button' class="google-signIn"> <svg class="" width="38" height="38">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c5146e64d7a7aab8$exports))}#google"></use>
        </svg></button>
        </div>
    </form>
    <div class='redirect-wrapper'>
    <p class='text'>or</p><button type=button class='redirect-btn signIn-btn-inModal'>Sign In</button>
    </div>
    `;
};
const $cef524a0898173f1$export$2cb316089bc201cf = ()=>{
    return `
  <strong class='auth-title'>Sign In</strong>
    <form class="signIn-form">
     <div class='input-wrapper'>
     <label class='auth-label' for="Email">Email</label>
      <input class="auth-input" placeholder="Email" name="email" type="email" />
      </div>
      <div class='input-wrapper'>
       <label class='auth-label' for="Password">Password</label>
      <input class="auth-input" placeholder="Password" name="password" type="password" />
      </div>
      <div class='submit-wrapper'>
       <button type='submit' class="auth-submit-btn submit-signIn">Sign In</button>
      <button type='button' class="google-signIn"> <svg class="" width="32" height="32">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($c5146e64d7a7aab8$exports))}#google"></use>
        </svg></button>
      </div>
  </form>
  <div class='redirect-wrapper'>
<p class='text'>or</p><button type=button class='redirect-btn signUp-btn-inModal'>Sign Up</button>
  </div>
  `;
};



var $l9ZQJ = parcelRequire("l9ZQJ");

var $613rw = parcelRequire("613rw");

var $eyjy7 = parcelRequire("eyjy7");

var $l9ZQJ = parcelRequire("l9ZQJ");

var $gyx0h = parcelRequire("gyx0h");

var $1GAPJ = parcelRequire("1GAPJ");
const $eafd45e9ea8c59a0$var$googleAuthProvider = new (0, $eyjy7.GoogleAuthProvider)();
async function $eafd45e9ea8c59a0$export$5e83cada0949b2a6() {
    try {
        await (0, $eyjy7.signInWithPopup)((0, $l9ZQJ.auth), $eafd45e9ea8c59a0$var$googleAuthProvider);
        (0, $gyx0h.onCloseModal)();
    } catch (e) {
        let message;
        if (e instanceof Error) message = e.message;
        else message = String(e);
        (0, $1GAPJ.Notify).failure(message);
    }
}



var $eyjy7 = parcelRequire("eyjy7");

var $1GAPJ = parcelRequire("1GAPJ");

var $gyx0h = parcelRequire("gyx0h");
async function $68a07d0fcad62380$export$9670d83f11d4b64a(auth, email, password) {
    try {
        await (0, $eyjy7.signInWithEmailAndPassword)(auth, email, password);
        (0, $gyx0h.onCloseModal)();
    } catch (e) {
        let message;
        if (e instanceof Error) message = e.message;
        else message = String(e);
        (0, $1GAPJ.Notify).failure(message);
    }
}



var $eyjy7 = parcelRequire("eyjy7");

var $1GAPJ = parcelRequire("1GAPJ");

var $gyx0h = parcelRequire("gyx0h");

var $asj7U = parcelRequire("asj7U");
async function $04b3ad8437884960$export$cf64224bcd829024(auth, name, email, password) {
    try {
        const credentials = await (0, $eyjy7.createUserWithEmailAndPassword)(auth, email, password);
        await (0, $eyjy7.updateProfile)(auth.currentUser, {
            displayName: name
        });
        (0, $asj7U.authRefs).currentUser.textContent = credentials.user.displayName;
        (0, $gyx0h.onCloseModal)();
    } catch (e) {
        let message;
        if (e instanceof Error) message = e.message;
        else message = String(e);
        (0, $1GAPJ.Notify).failure(message);
    }
}



var $dabnO = parcelRequire("dabnO");

var $eyjy7 = parcelRequire("eyjy7");
(0, $asj7U.authRefs).authBlock.addEventListener("click", $c4cd87d613d7a9e0$var$onClickAuthBlock);
let $c4cd87d613d7a9e0$var$formRef = null;
function $c4cd87d613d7a9e0$var$onClickAuthBlock(e) {
    if (e.target === (0, $asj7U.authRefs).signUp) {
        (0, $asj7U.modalRefs).modalContainer.classList.remove("modal-details-container");
        (0, $asj7U.modalRefs).modalContainer.classList.add("auth-container");
        (0, $7UV4g.modalRender)((0, $cef524a0898173f1$export$42ca48a105b71d6e)());
        (0, $gyx0h.onOpenModal)();
        $c4cd87d613d7a9e0$var$formRef = document.querySelector(".signUp-form");
    }
    if (e.target === (0, $asj7U.authRefs).signIn) {
        (0, $asj7U.modalRefs).modalContainer.classList.remove("modal-details-container");
        (0, $asj7U.modalRefs).modalContainer.classList.add("auth-container");
        (0, $7UV4g.modalRender)((0, $cef524a0898173f1$export$2cb316089bc201cf)());
        (0, $gyx0h.onOpenModal)();
        $c4cd87d613d7a9e0$var$formRef = document.querySelector(".signIn-form");
    }
    if (e.target === (0, $asj7U.authRefs).signOut) (0, $dabnO.signOutFunc)((0, $l9ZQJ.auth));
    if ($c4cd87d613d7a9e0$var$formRef) {
        $c4cd87d613d7a9e0$var$formRef.addEventListener("submit", $c4cd87d613d7a9e0$var$onSubmit);
        const googleAuthRef = document.querySelector(".google-signIn");
        googleAuthRef?.addEventListener("click", (0, $eafd45e9ea8c59a0$export$5e83cada0949b2a6));
    }
}
async function $c4cd87d613d7a9e0$var$onSubmit(e) {
    if (!$c4cd87d613d7a9e0$var$formRef) return;
    e.preventDefault();
    const formData = new FormData($c4cd87d613d7a9e0$var$formRef);
    const name = formData.get("name");
    const email = formData.get("email");
    const password = formData.get("password");
    $c4cd87d613d7a9e0$var$formRef.classList.contains("signUp-form") ? (0, $04b3ad8437884960$export$cf64224bcd829024)((0, $l9ZQJ.auth), name, email, password) : (0, $68a07d0fcad62380$export$9670d83f11d4b64a)((0, $l9ZQJ.auth), email, password);
}
(0, $eyjy7.onAuthStateChanged)((0, $l9ZQJ.auth), (user)=>{
    if (user !== null) {
        $c4cd87d613d7a9e0$var$authStyles(user);
        (0, $613rw.setDataFromLocalSrorage)("auth", user);
    } else {
        $c4cd87d613d7a9e0$var$notAuthStyles();
        (0, $613rw.setDataFromLocalSrorage)("auth", null);
    }
});
function $c4cd87d613d7a9e0$var$authController() {
    const user = (0, $613rw.getDataFromLocalStorage)("auth");
    if (user) $c4cd87d613d7a9e0$var$authStyles(user);
    else $c4cd87d613d7a9e0$var$notAuthStyles();
}
$c4cd87d613d7a9e0$var$authController();
function $c4cd87d613d7a9e0$var$authStyles(user) {
    (0, $asj7U.authRefs).signUp.style.display = "none";
    (0, $asj7U.authRefs).signIn.style.display = "none";
    (0, $asj7U.authRefs).signOut.style.display = "flex";
    (0, $asj7U.headerLinkRefs).library.style.pointerEvents = "";
    (0, $asj7U.headerLinkRefs).library.style.opacity = "1";
    (0, $asj7U.authRefs).currentUser.style.display = "block";
    (0, $asj7U.authRefs).currentUser.textContent = user.displayName;
    (0, $asj7U.authRefs).userWrapper.style.display = "flex";
}
function $c4cd87d613d7a9e0$var$notAuthStyles() {
    (0, $asj7U.authRefs).signUp.style.display = "inline-block";
    (0, $asj7U.authRefs).signIn.style.display = "inline-block";
    (0, $asj7U.authRefs).signOut.style.display = "none";
    (0, $asj7U.headerLinkRefs).library.style.pointerEvents = "none";
    (0, $asj7U.headerLinkRefs).library.style.opacity = "0.6";
    (0, $asj7U.authRefs).userWrapper.style.display = "none";
}




var $asj7U = parcelRequire("asj7U");

var $7UV4g = parcelRequire("7UV4g");



var $l9ZQJ = parcelRequire("l9ZQJ");


(0, $asj7U.modalRefs).modalContainer.addEventListener("click", $96af3a5685c23f83$var$onClickModalContainer);
let $96af3a5685c23f83$var$formRef = null;
function $96af3a5685c23f83$var$onClickModalContainer(e) {
    const signUpRef = document.querySelector(".signUp-btn-inModal");
    const signInRef = document.querySelector(".signIn-btn-inModal");
    if (e.target === signUpRef) {
        (0, $asj7U.modalRefs).modalContainer.classList.remove("modal-details-container");
        (0, $asj7U.modalRefs).modalContainer.classList.add("auth-container");
        (0, $7UV4g.modalRender)((0, $cef524a0898173f1$export$42ca48a105b71d6e)());
        $96af3a5685c23f83$var$formRef = document.querySelector(".signUp-form");
    }
    if (e.target === signInRef) {
        (0, $asj7U.modalRefs).modalContainer.classList.remove("modal-details-container");
        (0, $asj7U.modalRefs).modalContainer.classList.add("auth-container");
        (0, $7UV4g.modalRender)((0, $cef524a0898173f1$export$2cb316089bc201cf)());
        $96af3a5685c23f83$var$formRef = document.querySelector(".signIn-form");
    }
    if ($96af3a5685c23f83$var$formRef) {
        $96af3a5685c23f83$var$formRef.addEventListener("submit", $96af3a5685c23f83$var$onSubmit);
        const googleAuthRef = document.querySelector(".google-signIn");
        googleAuthRef?.addEventListener("click", (0, $eafd45e9ea8c59a0$export$5e83cada0949b2a6));
    }
}
async function $96af3a5685c23f83$var$onSubmit(e) {
    if (!$96af3a5685c23f83$var$formRef) return;
    e.preventDefault();
    const formData = new FormData();
    const name = formData.get("name");
    const email = formData.get("email");
    const password = formData.get("password");
    $96af3a5685c23f83$var$formRef.classList.contains("signUp-form") ? (0, $04b3ad8437884960$export$cf64224bcd829024)((0, $l9ZQJ.auth), name, email, password) : (0, $68a07d0fcad62380$export$9670d83f11d4b64a)((0, $l9ZQJ.auth), email, password);
}


parcelRequire("jspKm");


//# sourceMappingURL=index.e648bba4.js.map
